import { theme } from '@frontend/theme';
import { Avatar, Chip, Text } from '@frontend/design-system';

type TagChipProps = {
  name: string;
  onClick?: () => void;
  fullWidth?: boolean;
  tooltipLabel?: React.ReactNode | string;
};
export const TagChip = ({ name, onClick, fullWidth, tooltipLabel }: TagChipProps) => {
  return (
    <div
      css={{
        '.payment-field-chip': {
          maxWidth: fullWidth ? 'fit-content' : '',
        },
        '.payment-field-chip button>svg': {
          color: 'black',
        },
      }}
    >
      <Chip.Person
        className='payment-field-chip'
        css={{
          backgroundColor: theme.colors.primary5,
          border: 'none',
        }}
        onClick={onClick}
        variant='primary'
        avatar={<Avatar size='xxs' name={name} />}
        tooltipLabel={tooltipLabel}
      >
        <Text size='medium' as='span'>
          {name}
        </Text>
      </Chip.Person>
    </div>
  );
};
